import React, { useState } from "react";
import "./ImageGallery.css";
import Masonry from "react-responsive-masonry";

// Automatically import all images from folder
const importAll = (r) => r.keys().map(r);

const images = importAll(
  require.context("../Assets/Gallery", false, /\.(png|jpe?g|svg)$/)
);

const ImageGallery = () => {
  const [data, setData] = useState({ img: "", i: 0 });

  const viewImage = (img, i) => {
    setData({ img, i });
  };

  return (
    <>
      {data.img && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
            cursor: "pointer",
          }}
          onClick={() => setData({ img: "", i: 0 })}
        >
          <img
            src={data.img}
            alt="Gallery preview"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              objectFit: "contain",
            }}
          />
        </div>
      )}

      <div style={{ padding: "10px" }}>
        <Masonry columnsCount={3} gutter="10px">
          {images.map((image, i) => (
            <img
              key={i}
              src={image}
              alt={`Gallery ${i}`}
              style={{ width: "100%", display: "block", cursor: "pointer" }}
              onClick={() => viewImage(image, i)}
            />
          ))}
        </Masonry>
      </div>
    </>
  );
};

export default ImageGallery;
